import React, { useState } from 'react';
import { Formik, Form, FieldArray } from 'formik';
import * as Yup from 'yup';
import { map } from 'lodash';

import IngredientInput from './elements/IngredientInput';
import RecipeList from './RecipeList';
import RecipeSelect from './RecipeSelect';

import useWindowDimensions from '../hooks/useWindowDimensions';
import { getTotalCost } from '../utilities/content/costCalculations';
import { dummyRecipe } from '../api/dummyData';
import { labels } from '../configuration/labels';
import closeIcon from '../assets/icons/close.svg';

import '../styles/scss/components/calculator.scss';
import { BREAK_POINT_LG } from '../configuration/constants';

const Calculator = () => {
  const [selectedRecipe, setSelectedRecipe] = useState('');
  const [initialIngredientValues, setInitialIngredientValues] =
    useState(dummyRecipe);
  const [totalCost, setTotalCost] = useState(0);
  const [displayResult, setDisplayResult] = useState(false);

  const { width } = useWindowDimensions();
  const tableHeader = selectedRecipe
    ? selectedRecipe
    : labels.formHeaderTitleDefault;

  const validationSchema = Yup.object().shape({
    // ingredients: Yup.object().shape({
    //   amountPerPackage: Yup.number().required('Required field'),
    //   numberOfIngredients: Yup.string().required('Number of ingredients is required'),
    // }),
  });

  function handleSubmit(fields) {
    setTotalCost(getTotalCost(fields?.ingredients));
    setDisplayResult(true);
  }

  function handleRecipeChange(initialValue) {
    setInitialIngredientValues(initialValue);
    setDisplayResult(false);
  }

  return (
    <div className="calculator">
      {width > BREAK_POINT_LG ? (
        <RecipeList
          setSelectedRecipe={setSelectedRecipe}
          onRecipeChange={handleRecipeChange}
        />
      ) : (
        <RecipeSelect
          setSelectedRecipe={setSelectedRecipe}
          onRecipeChange={handleRecipeChange}
        />
      )}
      <div className="table">
        <h3>{tableHeader}</h3>
        <section className="table-header bold">
          <h5 className="col ingredient">{labels.formHeaderIngredient}</h5>
          <h5 className="col">{labels.formHeaderUnit}</h5>
          <h5 className="col">{labels.formHeaderAmountPerPackage}</h5>
          <h5 className="col">{labels.formHeaderCostPerPackage}</h5>
          <h5 className="col">{labels.formHeaderAmountPerRecipe}</h5>
          <h5 className="col">{labels.formHeaderCostBaht}</h5>
          <h5 className="col header-delete-row"> </h5>
        </section>
        <Formik
          initialValues={initialIngredientValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ errors, values, touched, setValues }) => (
            <Form>
              <FieldArray name="ingredients">
                {({ push, remove }) => (
                  <>
                    <div className="table-body">
                      {map(values.ingredients, (ingredient, index) => (
                        <div key={index} className="table-rows">
                          <IngredientInput
                            ingredient={ingredient}
                            index={index}
                          />
                          <div className="col delete-row">
                            <button
                              type="button"
                              className="btn btn-remove"
                              onClick={() => remove(index)}
                            >
                              <img alt="close" src={closeIcon} />
                            </button>
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="btn btn-add-more"
                        onClick={() =>
                          push({
                            name: 'วัตถุดิบอื่นๆ',
                            unit: 'หน่วย',
                            amountPerPackage: '1000',
                            costPerPackage: '250',
                            amountPerformula: '50',
                          })
                        }
                      >
                        {labels.formBtnAddMore}
                      </button>
                    </div>

                    <div className="table-footer">
                      <button type="submit" className="btn btn-calc">
                        {labels.formBtnCalculateCost}
                      </button>
                    </div>
                  </>
                )}
              </FieldArray>
            </Form>
          )}
        </Formik>
        {displayResult && (
          <section className="result-section">
            <p>{`${labels.resultCostSummary} ${totalCost?.toFixed(2)} ${
              labels.resultBaht
            }`}</p>
          </section>
        )}
      </div>
    </div>
  );
};

export default Calculator;
